'use strict';

( function ( $ ) {
	$( document ).on( 'click', '.sign-up button', function () {
		$( '.woocommerce-form-login' ).hide();
		$( '.woocommerce-form-register' ).show();
	} );
} )( jQuery );
